import { createEntityAdapter, EntityState } from '@ngrx/entity';

export interface Device {
  id: number;
  name: string;
  uniqueId: string;
  description: string;
  latitude: number | null;
  longitude: number | null;
  height: number | null;
  deviceModelId: number;
}

export const deviceAdapter = createEntityAdapter<Device>();

export interface DeviceState extends EntityState<Device> {
  deviceModels: { id: number; name: string }[];
}

export const initialDeviceState: DeviceState = deviceAdapter.getInitialState({
  deviceModels: [],
});
